import { createContext } from 'react';
import { AuthUser } from './auth0Api';

export type LogoutOptions = {
  returnTo?: string;
  logoutParams?: {
    returnTo?: string;
  };
};

export type AuthContextValue = {
  isAuthenticated: boolean;
  isLoading: boolean;
  user?: AuthUser;
  loginWithPassword: (email: string, password: string) => Promise<void>;
  signUpWithPassword: (
    email: string,
    password: string,
    fullName: string,
  ) => Promise<void>;
  requestPasswordReset: (email: string) => Promise<void>;
  startPasswordless: (email: string, send?: 'code' | 'link') => Promise<void>;
  verifyPasswordless: (email: string, otp: string) => Promise<void>;
  getAccessTokenSilently: (options?: {
    authorizationParams?: { audience?: string };
  }) => Promise<string>;
  logout: (options?: LogoutOptions) => void;
  loginWithRedirect: () => void;
  loginWithPopup: () => Promise<void>;
};

export const AuthContext = createContext<AuthContextValue | undefined>(
  undefined,
);
